const comMeta = { lang: 'zh' }

const newsCenter = [
  {
    path: '/news-center',
    name: `news-center`,
    component: () => import('@/views/news/newsCenter'),
    meta: {
      ...comMeta,
      title: '新闻中心',
      metaInfo: {
        title: '华盟·税纪云 _新闻中心'
      }
    }
  },
  {
    path: '/news-center-detail/:id',
    name: `news-center-detail`,
    component: () => import('@/views/news/newsCenter/newsDetail'),
    meta: {
      ...comMeta,
      title: '新闻详情',
      nav: 'news-center'
    }
  },
  {
    path: '/news-advertisement',
    name: `news-advertisement`,
    component: () => import('@/views/news/advertisement'),
    meta: {
      ...comMeta,
      title: '市场活动'
    }
  },
  {
    path: '/news-advertIntroduction/:id',
    name: `news-advertIntroduction`,
    component: () => import('@/views/news/advertisement/advertIntroduction'),
    meta: {
      ...comMeta,
      title: '活动详情',
      nav: 'news-advertisement'
    }
  }
]

export default newsCenter



// WEBPACK FOOTER //
// ./src/router/modules/news-center.js